export default "__VITE_ASSET__1eedf484__"